import React from 'react';
import PropTypes from 'prop-types';

import ObservationCardContainer from '../Containers/ObservationCardContainer';
import Container from '../Containers/Container';
import Card from '../Card';
import { T4D } from '../Text';

import { parseShortcodeArray } from '../../helpers/shortcode';

const FeaturedArticles = ({ articles: rawArticlesString }) => {
  // Remove the double quotes at the start and end of the string to be able to parse
  const articles = parseShortcodeArray(rawArticlesString);

  return (
    <Container>
      <T4D>Featured Articles</T4D>
      <ObservationCardContainer>
        {articles.map((article, i) => (
          <Card
            key={`${article.title}-${i}`}
            link={article.link}
            title={article.title}
            text={article.text}
          />
        ))}
      </ObservationCardContainer>
    </Container>
  );
};

FeaturedArticles.propTypes = {
  articles: PropTypes.string.isRequired
};

export default FeaturedArticles;
